import isAuth from '../router/isAuth'
import userStore from './usersStore'
import UserService from '../API/UserService'

async function firstUpdate() {
    if (isAuth()) {
        
        userStore.setState({
            user_profile: await UserService.getMyProfile()
        });
        userStore.setState({
            diamond: await UserService.getMyDiamond()
        });
        userStore.setState({
            rating: await UserService.getMyRating()
        });
        
    }
}

export default firstUpdate
// 11